/// <reference types="@emotion/react/types/css-prop" />
import * as React from 'react'
import * as Sentry from '@sentry/react'
import { Integrations } from '@sentry/tracing'
import ReactDOM from 'react-dom'
import tz from 'moment-timezone'
import Modal from 'react-modal'
import 'url-search-params-polyfill'

import Root from 'Root'
import theme from 'theme'

tz()

export interface ProcessEnv {
  env: {
    [key: string]: string | undefined
  }
}

declare let process: ProcessEnv

const {
  NODE_ENV,
  REACT_APP_RAVEN_DSN,
  REACT_APP_CIRCLE_BRANCH,
  REACT_APP_CIRCLE_SHA1
} = process.env

if (NODE_ENV === 'production') {
  try {
    Sentry.init({
      dsn: REACT_APP_RAVEN_DSN,
      environment:
        REACT_APP_CIRCLE_BRANCH || process.env.BRANCH || 'development',
      release: REACT_APP_CIRCLE_SHA1 || process.env.COMMIT_REF,
      integrations: [new Integrations.BrowserTracing()],
      tracesSampleRate: 1.0
    })
  } catch (err) {
    console.error('Unable to initialize Sentry:', err)
  }
}

const rootEl = document.getElementById('root')

Modal.setAppElement(rootEl)

Modal.defaultStyles.content = null
Modal.defaultStyles.overlay = null

interface ZESettingsWindow extends Window {
  zESettings: any
}

declare let window: ZESettingsWindow

window.zESettings = {
  webWidget: {
    offset: {
      vertical: '3px'
    },
    color: {
      theme: theme.colors.steel[2],
      launcherText: theme.colors.white[0]
    },
    zIndex: theme.zIndices[5]
  }
}

ReactDOM.render(<Root />, rootEl)
